webpackJsonp([110568472390859],{

/***/ 475:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/01_Track-card sort.38fb1740.jpg";

/***/ }),

/***/ 476:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/02_Track-User-testing.5bf07f1c.jpg";

/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/03_co-design workshop agenda.da752892.jpg";

/***/ }),

/***/ 478:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/04.1_co-design-workshop.c273f00f.jpg";

/***/ }),

/***/ 479:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/04_co-design-workshop.7b5c0eb3.jpg";

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/05_co-design-workshop.b8945ab3.jpg";

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/06_Story-board.3c3ce915.jpg";

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/07_runway-elaboration.30e0a3f2.jpg";

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/08_Synthesis-process.61c092f6.jpg";

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/10_Customer journey mapping_PO-Box.25dfadbb.jpg";

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/11_Contextual-Interview-UT.14697c7c.jpg";

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/14_retro-journey-mapping.bb7d8a70.jpg";

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/15_retro-storytelling.f834f1f2.jpg";

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/16_storytelling.e2918f22.jpg";

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/17_planning-sketches.e8fa26d8.jpg";

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/18_success-criteria-workshop.faeaca44.jpg";

/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactImageGallery = __webpack_require__(27);
	
	var _reactImageGallery2 = _interopRequireDefault(_reactImageGallery);
	
	__webpack_require__(25);
	
	var _TrackUserTesting = __webpack_require__(476);
	
	var _TrackUserTesting2 = _interopRequireDefault(_TrackUserTesting);
	
	var _coDesignWorkshopAgenda = __webpack_require__(477);
	
	var _coDesignWorkshopAgenda2 = _interopRequireDefault(_coDesignWorkshopAgenda);
	
	var _TrackCardSort = __webpack_require__(475);
	
	var _TrackCardSort2 = _interopRequireDefault(_TrackCardSort);
	
	var _coDesignWorkshop = __webpack_require__(479);
	
	var _coDesignWorkshop2 = _interopRequireDefault(_coDesignWorkshop);
	
	var _coDesignWorkshop3 = __webpack_require__(478);
	
	var _coDesignWorkshop4 = _interopRequireDefault(_coDesignWorkshop3);
	
	var _coDesignWorkshop5 = __webpack_require__(480);
	
	var _coDesignWorkshop6 = _interopRequireDefault(_coDesignWorkshop5);
	
	var _StoryBoard = __webpack_require__(481);
	
	var _StoryBoard2 = _interopRequireDefault(_StoryBoard);
	
	var _runwayElaboration = __webpack_require__(482);
	
	var _runwayElaboration2 = _interopRequireDefault(_runwayElaboration);
	
	var _SynthesisProcess = __webpack_require__(483);
	
	var _SynthesisProcess2 = _interopRequireDefault(_SynthesisProcess);
	
	var _CustomerJourneyMapping_POBox = __webpack_require__(484);
	
	var _CustomerJourneyMapping_POBox2 = _interopRequireDefault(_CustomerJourneyMapping_POBox);
	
	var _ContextualInterviewUT = __webpack_require__(485);
	
	var _ContextualInterviewUT2 = _interopRequireDefault(_ContextualInterviewUT);
	
	var _retroJourneyMapping = __webpack_require__(486);
	
	var _retroJourneyMapping2 = _interopRequireDefault(_retroJourneyMapping);
	
	var _retroStorytelling = __webpack_require__(487);
	
	var _retroStorytelling2 = _interopRequireDefault(_retroStorytelling);
	
	var _storytelling = __webpack_require__(488);
	
	var _storytelling2 = _interopRequireDefault(_storytelling);
	
	var _planningSketches = __webpack_require__(489);
	
	var _planningSketches2 = _interopRequireDefault(_planningSketches);
	
	var _successCriteriaWorkshop = __webpack_require__(490);
	
	var _successCriteriaWorkshop2 = _interopRequireDefault(_successCriteriaWorkshop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AuspostPage = function AuspostPage() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-5 project-info' },
	                _react2.default.createElement(
	                    'h3',
	                    null,
	                    'User Experience research in the postal industry'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'project-content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'During my time at Australia Post I have been the advocate for the end user on the consumer side as well as on the contract business side; and responsible for designing, conducting, analysing and reporting on user-centered design research and usability testing across the following Australia Post digital assets/ experiences: '
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'MyPost'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Track'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Delivery Choices and Safe Drop'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Actionable Notifications'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Parcel Locker'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Post Office Box'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Mail Redirection Service Online & Change of Address Notification'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Parcel Send - Online Lodgement Tool'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-lg-7' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'slider' },
	                    _react2.default.createElement(_reactImageGallery2.default, {
	                        showThumbnails: false,
	                        showFullscreenButton: false,
	                        autoPlay: true,
	                        items: [{ original: _TrackUserTesting2.default }, { original: _coDesignWorkshopAgenda2.default }, { original: _TrackCardSort2.default }, { original: _coDesignWorkshop2.default }, { original: _coDesignWorkshop4.default }, { original: _coDesignWorkshop6.default }, { original: _StoryBoard2.default }, { original: _runwayElaboration2.default }, { original: _SynthesisProcess2.default }, { original: _CustomerJourneyMapping_POBox2.default }, { original: _ContextualInterviewUT2.default }, { original: _retroJourneyMapping2.default }, { original: _retroStorytelling2.default }, { original: _storytelling2.default }, { original: _planningSketches2.default }, { original: _successCriteriaWorkshop2.default }] })
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'project-blurb' },
	                    'User Experience research in the postal industry'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    { className: 'tags' },
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Qualitative Interview'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Participative Observation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Ethnographic Listening'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Face-to-Face User testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Remote Testing and Guerrilla Prototype Testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Card Sorting'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Treejack testing'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Diary Study Research'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Survey'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Heuristic Evaluation'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Literature Review'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Competitive Analysis'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Co-Design Workshops'
	                    ),
	                    _react2.default.createElement(
	                        'li',
	                        null,
	                        'Success Criteria Workshops'
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'footer-info' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Cooperation Partner:'
	                        ),
	                        ' Australia Post'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'span',
	                            { className: 'highlight' },
	                            'Date:'
	                        ),
	                        ' 2015 - Present'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = AuspostPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-auspost-js-c5bebb08a367157ed770.js